/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


import state from './moduleCoachingExperienceState.js'
import mutations from './moduleCoachingExperienceMutations.js'
import actions from './moduleCoachingExperienceActions.js'
import getters from './moduleCoachingExperienceGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

